<template>
    <div ref="panel" :class="cssClasses" :style="styles">
        <center v-if="showPanelSwitches">
            <div class="bg-white" style="border: 1px solid #ccc; border-top-width: 0; width: 140px; font-size: 14px; ">
                <b-link href="#" @click="changePanelState" class="text-decoration-none" v-if="!notCollapsible">{{ panelActionString }} |</b-link>
                <b-link href="#" @click="changeStickyState" class="text-decoration-none"> {{ panelStickyString }}</b-link>
            </div>
        </center>
        <slot v-bind:collapsed="collapsed"></slot>
    </div>
</template>

<script>
         
    export default {
        name: 'StickyPanel',
        props: {
            stickyTop: {
                type: Boolean,
                default: true
            },
            stickyBottom: {
                type: Boolean,
                default: false
            },
            backgroundColor: {
                type: String,
                default: '#FFF'
            },
            containerMargin: {
                type: String,
                default: '1.5rem'
            },
            containerMarginLeft: {
                type: String,
                default: null
            },
            containerMarginRight: {
                type: String,
                default: null
            },
            cssClass: {
                type: String,
                default: 'sticky-panel'
            },
            stickyTopCssClass: {
                type: String,
                default: 'sticky-panel-sticky-top'
            },
            stickyBottomCssClass: {
                type: String,
                default: 'sticky-panel-sticky-bottom'
            },
            notCollapsible: {
                type: Boolean,
                default: false
            },
            showPanelSwitches: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                isStickyTop: false,
                isStickyBottom: false,
                lastScrollTop: 0,
                sticky: true,
                collapsed: false,

                // josef
                panelActionString: 'Collapse',
                panelStickyString: 'Unfreeze'
            }
        },
        computed: {
            cssClasses() {
                var classes = [];
                classes.push(this.cssClass);
                if(this.isStickyTop) classes.push(this.stickyTopCssClass);
                if(this.isStickyBottom) classes.push(this.stickyBottomCssClass);
                return classes;
            },
            styles() {

                var styles = {};

                // josef
                if (this.sticky) {
                    styles = {
                        position: 'sticky',
                        'z-index': 900,
                        
                    };
                    if (this.stickyTop) styles.top = 0;
                    if (this.stickyBottom) styles.bottom = 0;
                }

                styles['border-top'] = '2px solid #CCC';
                styles['border-bottom'] = '2px solid #CCC';
               
                if(this.backgroundColor) styles['background-color'] = this.backgroundColor;
                                
                if(this.containerMargin || this.containerMarginLeft) {
                    if(this.containerMarginLeft){
                        styles['margin-left'] = '-' + this.containerMarginLeft;
                        styles['padding-left'] = this.containerMarginLeft;
                    } else {
                        styles['margin-left'] = '-' + this.containerMargin;
                        styles['padding-left'] = this.containerMargin;
                    }
                }
                if(this.containerMargin || this.containerMarginRight) {
                    if(this.containerMarginRight){
                        styles['margin-right'] = '-' + this.marginLeft;
                        styles['padding-right'] = this.marginLeft;
                    } else {
                        styles['margin-right'] = '-' + this.containerMargin;
                        styles['padding-right'] = this.containerMargin;
                    }
                }

                return styles;
            }
        },
        methods: {
            // josef
            changePanelState: function () {
                this.collapsed = !this.collapsed;
                this.panelActionString = (this.collapsed) ? 'Expand' : 'Collapse';
            },
            changeStickyState: function () {
                this.sticky = !this.sticky;
                this.panelStickyString = (this.sticky) ? 'Unfreeze' : 'Freeze';
            },

            getScrollTop() {
                return window.pageYOffset || document.documentElement.scrollTop;
            },
            check() {
                var elem = this.$refs.panel;
                var panelTop = elem.offsetTop;
                var panelHeight = elem.offsetHeight;
                elem = elem.offsetParent;
                while (elem) {
                    panelTop += elem.offsetTop;
                    elem = elem.offsetParent;
                }
                var panelBottom = panelTop + panelHeight;
                var currentScrollPos = this.getScrollTop();
                var currentScrollBottomPos = currentScrollPos + window.innerHeight || document.documentElement.clientHeight;
                var newIsStickyTop = this.stickyTop && currentScrollPos > panelTop;
                var newIsStickyBottom = this.stickyBottom && currentScrollBottomPos < panelBottom;

                this.lastScrollTop = currentScrollPos

                if ((this.isStickyTop !== newIsStickyTop) || (this.isStickyBottom !== newIsStickyBottom)) {
                    this.isStickyTop = newIsStickyTop;
                    this.isStickyBottom = newIsStickyBottom;
                    this.$emit('change', { stickyTop: this.isStickyTop, stickyBottom: this.isStickyBottom });
                }
            }
        },

        mounted() {
            this.lastScrollTop = this.getScrollTop();
            window.addEventListener('scroll', this.check);
            this.check();
        },

        beforeDestroy() {
            window.removeEventListener('scroll', this.check);
        }
    }
</script>
